import SignUp from "../SignUp"
import { useMultiPage } from "../../util/useMultiPage"

interface LandingComponentProps {
  landingBackButtonUrl: string
  signUpText: Record<string, string>
}

export default function Landing({
  landingBackButtonUrl,
  signUpText
}: LandingComponentProps): JSX.Element {
  const allPages: Array<JSX.Element> = [
    <SignUp
      landingBackButtonUrl={landingBackButtonUrl}
      signUpText={signUpText}
    />
  ]

  const { currentPage } = useMultiPage(allPages)

  return <div className="main">{currentPage}</div>
}
